import React, { type ComponentType } from 'react';
import { Text } from '@atlaskit/primitives';
import Bar, { type APIProps as BarProps } from './bar';
import Chart, { type APIProps as ChartProps } from './chart';
import ChartIndicators, { type APIProps as ChartIndicatorsProps } from './chart-indicators';
import ChartItem, { type APIProps as ChartItemProps } from './chart-item';
import ChartOverlay, { type APIProps as ChartOverlayProps } from './chart-overlay';
import Legend from './legend';
import List, { type APIProps as ListProps } from './list';
import ListItem, { type APIProps as ListItemProps } from './list-item';
import ListItemContent, { type APIProps as ListItemContentProps } from './list-item-content';
import ListItemContentTooltip, {
	type APIProps as ListItemContentTooltipProps,
} from './list-item-content-tooltip';

type ListComponentType = ComponentType<ListProps>;
type ListItemComponentType = ComponentType<ListItemProps>;
type ListItemContentComponentType = ComponentType<ListItemContentProps>;
type ListItemContentTooltipComponentType = ComponentType<ListItemContentTooltipProps>;
type ChartComponentType = ComponentType<ChartProps>;
type ChartItemComponentType = ComponentType<ChartItemProps>;
type BarComponentType = ComponentType<BarProps>;
type ChartOverlayComponentType = ComponentType<ChartOverlayProps>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ChartLegendComponentType = ComponentType<Record<any, any>>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ChartLoaderComponentType = ComponentType<Record<any, any>>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NoMatchesComponentType = ComponentType<Record<any, any>>;
type ChartIndicatorsComponentType = ComponentType<ChartIndicatorsProps>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IssueTitleComponentType = ComponentType<Record<any, any>>;
type Components = {
	List: ListComponentType;
	ListItem: ListItemComponentType;
	ListItemContent: ListItemContentComponentType;
	ListItemContentTooltip: ListItemContentTooltipComponentType;
	Chart: ChartComponentType;
	ChartItem: ChartItemComponentType;
	Bar: BarComponentType;
	ChartOverlay: ChartOverlayComponentType;
	Legend: ChartLegendComponentType;
	Loader: ChartLoaderComponentType;
	NoMatches: NoMatchesComponentType;
	ChartIndicators: ChartIndicatorsComponentType;
	IssueTitle: IssueTitleComponentType;
};

export const components = {
	List,
	ListItem,
	ListItemContent,
	ListItemContentTooltip,
	Chart,
	ChartItem,
	Bar,
	ChartOverlay,
	Legend,
	Loader: () => null,
	NoMatches: () => null,
	ChartIndicators,
	IssueTitle: () => <Text>Issues Title</Text>,
} as const;

export type {
	Components,
	ListProps,
	ListComponentType,
	ListItemProps,
	ListItemComponentType,
	ListItemContentProps,
	ListItemContentTooltipProps,
	ListItemContentComponentType,
	ListItemContentTooltipComponentType,
	ChartProps,
	ChartComponentType,
	ChartItemProps,
	ChartItemComponentType,
	BarProps,
	BarComponentType,
	ChartOverlayProps,
	ChartOverlayComponentType,
	ChartIndicatorsProps,
	ChartIndicatorsComponentType,
};
